(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var main = document.querySelector('.rg-buy__main');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-rg-thumb]'));
    if (main && thumbs.length > 1) {
      var step = function (dir) {
        var i = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
        if (i < 0) i = 0;
        thumbs[(i + dir + thumbs.length) % thumbs.length].click();
      };
      [['prev', -1, '\u2039', 'Previous image'], ['next', 1, '\u203a', 'Next image']].forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rg-arrow rg-arrow--' + a[0];
        b.setAttribute('aria-label', a[3]);
        b.textContent = a[2];
        b.addEventListener('click', function () { step(a[1]); });
        main.appendChild(b);
      });
    }
    var box = document.querySelector('.rg-quotes');
    if (box) {
      var qs = Array.prototype.slice.call(box.querySelectorAll('.rg-quote'));
      if (qs.length > 1) {
        var dots = document.createElement('div');
        dots.className = 'rg-dots';
        var cur = 0;
        var timer;
        var show = function (n) {
          cur = (n + qs.length) % qs.length;
          qs.forEach(function (q, i) { q.hidden = i !== cur; });
          Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === cur); });
        };
        qs.forEach(function (q, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.setAttribute('aria-label', 'Show quote ' + (i + 1));
          d.addEventListener('click', function () { show(i); clearInterval(timer); });
          dots.appendChild(d);
        });
        box.appendChild(dots);
        show(0);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = setInterval(function () { show(cur + 1); }, 5000);
        }
      }
    }
  });
})();
